<script lang="ts" setup></script>

<template>
  <div class="text-center text-black-80">
    {{ $t("dialogsAndModals.organism.loginAndRegistration.otherwise") }}
  </div>
</template>
